import { Link } from "react-router-dom";
import SearchBar from "@/components/base/SearchBar";
import { comics } from "@/mocks/comics";
import { categories } from "@/mocks/categories";

const hotKeywords = ["热血", "恋爱", "奇幻", "校园", "悬疑"];

const keywordSlug: Record<string, string> = {
  热血: "rexue",
  恋爱: "lianai",
  奇幻: "qihuan",
  校园: "xiaoyuan",
  悬疑: "xuanyi",
};

export default function HomeHero() {
  const totalDownloads = comics.reduce((sum, comic) => sum + comic.downloads, 0);

  const stats = [
    { icon: "ri-book-shelf-line", value: `${comics.length}`, label: "收录作品" },
    { icon: "ri-price-tag-3-line", value: `${categories.length}`, label: "漫画分类" },
    { icon: "ri-download-cloud-2-line", value: `${Math.round(totalDownloads / 10000)}万+`, label: "累计下载" },
  ];

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20geometric%20deep%20navy%20background%20with%20glowing%20orange%20light%20streaks%20and%20subtle%20comic%20panel%20grid%20lines%2C%20modern%20minimal%20digital%20art%2C%20high%20contrast%2C%20clean%20composition%20without%20text&width=1600&height=600&seq=jm-hero-band&orientation=landscape"
        alt="禁漫天堂漫画下载平台背景"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-55"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/75 via-primary-950/70 to-primary-950/85" />

      <div className="relative z-10 flex w-full flex-col items-center px-4 py-14 text-center md:px-6 md:py-20">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium text-background-50">
          <i className="ri-fire-fill text-accent-400" />
          热门漫画下载 · 离线收藏首选
        </span>

        <h1 className="mt-5 max-w-3xl text-balance font-heading text-2xl font-extrabold leading-tight text-background-50 md:text-4xl">
          禁漫天堂 · 热门漫画下载平台
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-primary-100/85 md:text-base">
          涵盖热血、恋爱、奇幻等十大类型，分类浏览、快速搜索、清晰作品信息与下载入口，一站在手，想看就下。
        </p>

        <div className="mt-7 w-full max-w-2xl">
          <SearchBar size="lg" placeholder="输入漫画标题、作者或类型，回车即可搜索" />
        </div>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-primary-200/80">热门搜索：</span>
          {hotKeywords.map((keyword) => (
            <Link
              key={keyword}
              to={`/category/${keywordSlug[keyword]}`}
              className="cursor-pointer whitespace-nowrap rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1 text-xs text-background-50 transition-colors hover:border-accent-400 hover:text-accent-400"
            >
              {keyword}
            </Link>
          ))}
        </div>

        <div className="mt-9 grid w-full max-w-2xl grid-cols-3 gap-3 md:gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center rounded-lg border border-background-50/10 bg-background-50/5 px-3 py-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                <i className={`${stat.icon} text-xl`} />
              </span>
              <span className="mt-2 font-heading text-lg font-extrabold text-background-50 md:text-xl">{stat.value}</span>
              <span className="mt-0.5 text-xs text-primary-200/80">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}